import { z } from 'zod';
import { NotificationActionType } from '~/enums/_types';
import { zGuid, zLuxonDateTime } from '~/plugins/zod/utils';

export const NotificationStatusSchema = z.object({
    Read: z.number(),
    Unread: z.number(),
});

export const NotificationInfoSchema = z.object({
    Id: zGuid(),
    Type: z.nativeEnum(NotificationActionType),
    CreatedAt: zLuxonDateTime({ iso: true }),
    ReadAt: zLuxonDateTime({ iso: true }).nullable(),
    AdditionalInfo: z.unknown().nullable(),
});

export const NotificationListSchema = z.object({
    Notifications: z.array(NotificationInfoSchema),
    Status: NotificationStatusSchema,
});

export const NotificationDetailSchema = z.object({
    Notification: NotificationInfoSchema,
    Status: NotificationStatusSchema,
});

export type NotificationStatus = z.infer<typeof NotificationStatusSchema>;
export type NotificationInfo = z.infer<typeof NotificationInfoSchema>;
export type NotificationList = z.infer<typeof NotificationListSchema>;
export type NotificationDetail = z.infer<typeof NotificationDetailSchema>;
